import { create } from "zustand";

export interface GameChatMessage {
  id: string;
  sender: string;
  text: string;
  mine?: boolean;
}

export interface ActiveGameChat {
  roomId: string;
  title: string; // e.g. "Poker table"
  messages: GameChatMessage[];
  unread: number;
  send: (text: string) => void;
}

interface GameChatState {
  active: ActiveGameChat | null;
  /** Called by a game session to expose its public chat to the dock. */
  setActiveGameChat: (chat: ActiveGameChat | null) => void;
  clearActiveGameChat: (roomId?: string) => void;
}

function sameMessages(a: GameChatMessage[], b: GameChatMessage[]): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const x = a[i];
    const y = b[i];
    if (x.id !== y.id || x.text !== y.text || x.sender !== y.sender || !!x.mine !== !!y.mine) return false;
  }
  return true;
}

/** Same chat, same content — setting it again would only re-render the dock. */
export function sameGameChat(a: ActiveGameChat | null, b: ActiveGameChat | null): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  return (
    a.roomId === b.roomId &&
    a.title === b.title &&
    a.unread === b.unread &&
    a.send === b.send &&
    sameMessages(a.messages, b.messages)
  );
}

export const useGameChatStore = create<GameChatState>((set, get) => ({
  active: null,
  setActiveGameChat: (chat) => {
    if (!sameGameChat(get().active, chat)) set({ active: chat });
  },
  clearActiveGameChat: (roomId) => {
    const cur = get().active;
    if (!roomId || cur?.roomId === roomId) set({ active: null });
  },
}));
